import * as React from 'react'

import { Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type Props = {
  children: React.ReactNode
}

export const NonWeightableTooltip = ({ children }: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.Alt
      attachment="bottom center"
      open={open}
      toggle={toggle}
      label={i18n.t('performance_process.section_weights.missing_rating_question')}
    >
      {children}
    </Tooltip.Alt>
  )
}
